import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3cfa4c4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group-details-view" }
const _hoisted_2 = {
  key: 0,
  "data-test": "gd-waiting-for-data",
  style: {"display":"none"}
}
const _hoisted_3 = {
  key: 1,
  class: "page-container"
}
const _hoisted_4 = { "data-test": "gd-name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "margin-bottom flex" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "margin-bottom"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Organisation", -1))
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 1,
  class: "margin-bottom"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Subscription", -1))
const _hoisted_15 = { "data-test": "gd-subs" }
const _hoisted_16 = {
  key: 0,
  "data-test": "gd-subs-no-fixed"
}
const _hoisted_17 = {
  key: 1,
  "data-test": "gd-subs-fixed"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { "data-test": "gd-subs-duration" }
const _hoisted_20 = {
  key: 2,
  class: "margin-bottom",
  "data-test": "gd-created"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Created by", -1))
const _hoisted_22 = ["href"]
const _hoisted_23 = {
  class: "margin-bottom",
  "data-test": "gd-notes"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Notes", -1))
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "margin-bottom" }
const _hoisted_28 = ["href"]
const _hoisted_29 = {
  class: "margin-bottom",
  "data-test": "gd-summary-link"
}
const _hoisted_30 = ["href"]
const _hoisted_31 = { class: "team-links margin-bottom" }
const _hoisted_32 = ["href"]
const _hoisted_33 = ["href"]
const _hoisted_34 = ["href"]
const _hoisted_35 = ["href"]
const _hoisted_36 = ["href"]
const _hoisted_37 = ["href"]
const _hoisted_38 = ["href"]
const _hoisted_39 = ["href"]
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_42 = { class: "row nav-row margin-bottom" }
const _hoisted_43 = { class: "col-sm-8" }
const _hoisted_44 = {
  class: "nav nav-pills tab-list",
  role: "tablist"
}
const _hoisted_45 = {
  key: 0,
  "data-test": "members-tab-info",
  id: "members"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Members", -1))
const _hoisted_47 = { "data-test": "gd-members-count" }
const _hoisted_48 = { "data-test": "gd-members-active-subs" }
const _hoisted_49 = { "data-test": "gd-members-conflicting-subs" }
const _hoisted_50 = {
  key: 1,
  "data-test": "admins-tab-info",
  id: "team-leads"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Team Leads", -1))
const _hoisted_52 = { "data-test": "gd-admins-count" }
const _hoisted_53 = {
  key: 0,
  class: "margin-bottom"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Admins who aren't members of this team:", -1))
const _hoisted_55 = {
  class: "non-member-role-list",
  "data-test": "non-member-admin-list"
}
const _hoisted_56 = ["href"]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = {
  key: 2,
  "data-test": "watchers-tab-info",
  id: "watchers"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Watchers", -1))
const _hoisted_60 = { "data-test": "gd-watchers-count" }
const _hoisted_61 = {
  key: 0,
  class: "margin-bottom"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Watchers who aren't members of this team:", -1))
const _hoisted_63 = {
  class: "non-member-role-list",
  "data-test": "non-member-watcher-list"
}
const _hoisted_64 = ["href"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_67 = { class: "button-container" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_69 = {
  class: "table-container",
  "data-test": "gd-table-container"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: '/admin/group/list/teams',
      "data-test": "gd-teams-link"
    }, "Teams"),
    /*#__PURE__*/_createTextVNode(" | "),
    /*#__PURE__*/_createElementVNode("a", {
      href: '/admin/group/list/subgroups',
      "data-test": "gd-subgroups-link"
    }, "Subscription Groups"),
    /*#__PURE__*/_createTextVNode(" | "),
    /*#__PURE__*/_createElementVNode("a", {
      href: '/admin/group/list/plaingroups',
      "data-test": "gd-plain-link"
    }, "Plain Groups"),
    /*#__PURE__*/_createTextVNode(" | "),
    /*#__PURE__*/_createElementVNode("a", {
      href: '/admin/group/list/allgroups',
      "data-test": "gd-all-link"
    }, "All")
  ])
], -1))

import { computed, ref, watchEffect } from "vue";
import { Modal } from "uiv";
import { useRoute } from "vue-router";
import LoadingPage from "../../loading-page.vue";
import { GroupUserRoles } from "../../../components/admin/group/group-user-roles.enum";
import GroupDetailsTable from "../../../components/admin/group/group-details-table.vue";
import DeleteLicenceModal from "../../../components/admin/group/delete-licence-modal.vue";
import EditRoleModal from "../../../components/admin/group/edit-role-modal.vue";
import RemoveNonMemberRoleModal from "../../../components/admin/group/remove-non-member-role-modal.vue";
import AddNonMemberRoleModal from "../../../components/admin/group/add-non-member-role-modal.vue";
import EditMembersModal from "../../../components/admin/group/edit-group-members-modal.vue";
import AssignLicenceModal from "../../../components/admin/group/assign-licence-modal.vue";
import { HttpMethods, useAxios } from "../../../composables/api";
import {
  GroupDetailsApiModel,
  GroupUserRoleApiModel,
  InviteControlApiModel,
  LicenceApiModel,
  TeamCurrentMemberApiModel,
} from "../../../api-models";
import InviteControl from "../../../components/invite-control/invite-control.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'group-details-page',
  setup(__props) {

const route = useRoute();

const teamId: string = route.params.teamId as string;
const showLicenceModal = ref(false);
const showAssignLicenceModal = ref(false);
const memberWithLicence = ref<LicenceApiModel | null>(null);
const showRoleModal = ref(false);
const memberToEditRoleFor = ref<TeamCurrentMemberApiModel | null>(null);
const roleToEdit = ref<string>("");
let roleSubmitError = ref<number | null>(null);
const isAddingRole = ref<boolean | null>(null);
const nonMemberToDelete = ref<GroupUserRoleApiModel | null>(null);
const memberToAssignLicenceTo = ref<TeamCurrentMemberApiModel | null>(null);
const showNonMemberModal = ref(false);
const showAddRoleModal = ref(false);
const showEditMembersModal = ref(false);
const selectedFilter = ref<GroupUserRoles>(GroupUserRoles.Member);
const showInviteControl = ref(false);
const inviteModel = ref<InviteControlApiModel | null>(null);
const isWaitingForData = ref(false);

const { data: groupDetails, refreshData } = useAxios<GroupDetailsApiModel>(
  `/api/admin/groupdetails/${teamId}`,
);

const refreshGroupDetails = async () => {
  isWaitingForData.value = true;
  await refreshData();
  isWaitingForData.value = false;
};

const { data: inviteControlMultipleUseModel } = useAxios<InviteControlApiModel>(
  `/api/admin/groupinvite/${teamId}`,
);

const { data: inviteControlSingleUseModel } = useAxios<InviteControlApiModel>(
  `/api/admin/groupinvite/${teamId}?isSingleUse=true&allowServerSend=false`,
);

const isGroupDetailsLoaded = computed(() => !!groupDetails.value);

const scratchpadLink = computed(() => {
  const url = new URL("/scratchpad", window.location.origin);
  url.searchParams.set("subject", "Team");
  url.searchParams.set("id", teamId);
  return url;
});

const teamMembers = computed(() => {
  return groupDetails.value?.groupMembers ?? [];
});

const membersUserDetails = computed({
  get: () => {
    return (
      groupDetails.value?.groupMembers.map((m) => {
        return m.userDetails;
      }) ?? []
    );
  },
  set: (newValue) => {
    return newValue;
  },
});

const hasSubscription = computed(() => {
  return !!groupDetails.value?.subscription?.durationInMonths;
});

const teamAdmins = computed(() => {
  const roles = groupDetails.value?.roles ?? [];

  if (!roles.length) {
    return [];
  }

  return roles.filter((role) => {
    return role.role.toLowerCase() === GroupUserRoles.Admin;
  });
});

const teamWatchers = computed(() => {
  const roles = groupDetails.value?.roles ?? [];

  if (!roles.length) {
    return [];
  }

  return roles.filter((role) => {
    return role.role.toLowerCase() === GroupUserRoles.Watcher;
  });
});

const nonMemberRoles = (
  roles: GroupUserRoleApiModel[],
  role: GroupUserRoles,
): GroupUserRoleApiModel[] => {
  const filterByRole = roles.filter((r) => {
    return r.role === role;
  });
  const memberIds: string[] = [];
  teamMembers?.value?.forEach((m) => {
    memberIds.push(m.userDetails.id);
  });
  return filterByRole.filter((r) => {
    return !memberIds.includes(r.id);
  });
};

const nonMembersWithRoles = computed(() => {
  if (groupDetails.value) {
    if (selectedFilter.value === GroupUserRoles.Admin) {
      return "roles" in groupDetails.value
        ? nonMemberRoles(groupDetails.value.roles, GroupUserRoles.Admin)
        : [];
    }

    if (selectedFilter.value === GroupUserRoles.Watcher) {
      return "roles" in groupDetails.value
        ? nonMemberRoles(groupDetails.value.roles, GroupUserRoles.Watcher)
        : [];
    }
  }
  return [];
});

const filteredMembers = computed(() => {
  const groupMembers = groupDetails.value?.groupMembers || [];

  if (!groupMembers.length) {
    return [];
  }

  if (selectedFilter.value === GroupUserRoles.Admin) {
    return groupMembers.filter((gm) => {
      return gm.roles.some((role) => role.role.toLowerCase() === "admin");
    });
  }

  if (selectedFilter.value === GroupUserRoles.Watcher) {
    return groupMembers.filter((gm) => {
      return gm.roles.some((role) => role.role.toLowerCase() === "watcher");
    });
  }

  return groupMembers;
});

const orgId = computed(() => {
  return groupDetails.value?.organisationId;
});

const inviteControlModel = computed({
  get: () => {
    return inviteModel.value;
  },
  set: (newValue) => {
    inviteModel.value = newValue as InviteControlApiModel;
  },
});

const applyFilter = (filter: GroupUserRoles): void => {
  selectedFilter.value = filter;
};

const addingOrRemovingRole = (member: TeamCurrentMemberApiModel, role: string): void => {
  isAddingRole.value =
    member.roles.filter((r) => {
      return (
        r.role === role.toLowerCase() && r.groupId === teamId && r.id === member.userDetails.id
      );
    }).length === 0;
};

const openRoleModal = (member: TeamCurrentMemberApiModel, role: string): void => {
  addingOrRemovingRole(member, role);
  memberToEditRoleFor.value = member;
  showRoleModal.value = true;
  roleToEdit.value = role.toLowerCase();
};

const closeRoleModal = (): void => {
  showRoleModal.value = false;
  roleSubmitError = ref<number | null>(null);
  isAddingRole.value = null;
};

const toggleLicenceModal = (member?: LicenceApiModel): void => {
  if (member) {
    memberWithLicence.value = member;
  }
  showLicenceModal.value = !showLicenceModal.value;
};

const toggleAssignLicenceModal = (member?: TeamCurrentMemberApiModel): void => {
  showAssignLicenceModal.value = !showAssignLicenceModal.value;
  if (!member) {
    memberToAssignLicenceTo.value = null;
  } else {
    memberToAssignLicenceTo.value = member;
  }
};

const openNonMemberModal = (userRole: GroupUserRoleApiModel): void => {
  nonMemberToDelete.value = userRole;
  showNonMemberModal.value = true;
};

const closeNonMemberModal = (): void => {
  showNonMemberModal.value = false;
};

const toggleAddNonMemberRoleModal = (isRefreshNeeded?: boolean): void => {
  showAddRoleModal.value = !showAddRoleModal.value;
  if (isRefreshNeeded) {
    refreshGroupDetails();
  }
};

const toggleEditMembersModal = (isRefreshNeeded?: boolean): void => {
  showEditMembersModal.value = !showEditMembersModal.value;
  if (isRefreshNeeded) {
    refreshGroupDetails();
  }
};

const openInviteModal = (isForOnePerson: boolean): void => {
  if (isForOnePerson) {
    inviteControlModel.value = inviteControlSingleUseModel.value;
  } else {
    inviteControlModel.value = inviteControlMultipleUseModel.value;
  }
  showInviteControl.value = true;
};

const removeLicenceForMember = (id: string): void => {
  const { promise } = useAxios(`/api/admin/removelicence/${id}`, { httpMethod: "DELETE" });
  promise.then(() => {
    toggleLicenceModal();
    refreshGroupDetails();
  });
};

const assignLicenceToMember = (id: string): void => {
  const { promise } = useAxios(`/api/admin/assignlicence/${id}`, { httpMethod: "POST" });
  promise.then(() => {
    toggleAssignLicenceModal();
    refreshGroupDetails();
  });
};

const deleteRole = async (userRole: GroupUserRoleApiModel, isMember: boolean): Promise<void> => {
  const { promise, errorStatus } = useAxios("/api/admin/teamrole", {
    data: userRole,
    isFatal: false,
    httpMethod: "DELETE" as HttpMethods,
  });
  roleSubmitError = errorStatus;
  promise.then(() => {
    if (isMember) {
      closeRoleModal();
    } else {
      closeNonMemberModal();
    }

    refreshGroupDetails();
  });
};

const submitEditRole = async (member: TeamCurrentMemberApiModel, role: string): Promise<void> => {
  const memberFullName = `${member.userDetails.firstName} ${member.userDetails.lastName}`;
  const editUserRole: GroupUserRoleApiModel = {
    id: member.userDetails.id,
    groupId: teamId,
    name: memberFullName,
    role: role.toLowerCase(),
  };

  if (isAddingRole.value) {
    const { promise, errorStatus } = useAxios<GroupUserRoleApiModel>("/api/admin/teamrole", {
      isFatal: false,
      data: editUserRole,
      httpMethod: "POST" as HttpMethods,
    });
    roleSubmitError = errorStatus;
    promise.then(() => {
      closeRoleModal();
      refreshGroupDetails();
    });
  } else {
    await deleteRole(editUserRole, true);
  }
};

const copySubInviteCode = async () => {
  try {
    if (inviteControlMultipleUseModel.value) {
      await navigator.clipboard.writeText(inviteControlMultipleUseModel.value.inviteUrl);
      // eslint-disable-next-line no-alert
      alert("Invite code copied to clipboard!");
    }
  } catch (e) {
    // eslint-disable-next-line no-alert
    alert("Cannot copy");
  }
};

watchEffect(() => {
  if (!showInviteControl.value) {
    setTimeout(() => {
      inviteControlModel.value = null;
    }, 1000);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isWaitingForData.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (isGroupDetailsLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (memberToAssignLicenceTo.value)
            ? (_openBlock(), _createBlock(AssignLicenceModal, {
                key: 0,
                "show-modal": showAssignLicenceModal.value,
                "group-member": memberToAssignLicenceTo.value,
                onToggleAssignLicenceModal: toggleAssignLicenceModal,
                onAssignLicence: assignLicenceToMember
              }, null, 8, ["show-modal", "group-member"]))
            : _createCommentVNode("", true),
          (showLicenceModal.value)
            ? (_openBlock(), _createBlock(DeleteLicenceModal, {
                key: 1,
                memberWithLicence: memberWithLicence.value,
                showLicenceModal: showLicenceModal.value,
                onToggleLicenceModal: toggleLicenceModal,
                onDeleteLicence: removeLicenceForMember
              }, null, 8, ["memberWithLicence", "showLicenceModal"]))
            : _createCommentVNode("", true),
          (showRoleModal.value)
            ? (_openBlock(), _createBlock(EditRoleModal, {
                key: 2,
                member: memberToEditRoleFor.value,
                showRoleModal: showRoleModal.value,
                role: roleToEdit.value,
                error: !!_unref(roleSubmitError),
                isAddingRole: isAddingRole.value,
                onCloseRoleModal: closeRoleModal,
                onConfirmRole: submitEditRole
              }, null, 8, ["member", "showRoleModal", "role", "error", "isAddingRole"]))
            : _createCommentVNode("", true),
          _createVNode(RemoveNonMemberRoleModal, {
            userRole: nonMemberToDelete.value,
            showNonMemberModal: showNonMemberModal.value,
            error: !!_unref(roleSubmitError),
            onRemoveNonMemberRole: _cache[0] || (_cache[0] = ($event: any) => (deleteRole(nonMemberToDelete.value, false))),
            onCloseNonMemberModal: closeNonMemberModal
          }, null, 8, ["userRole", "showNonMemberModal", "error"]),
          _createVNode(AddNonMemberRoleModal, {
            role: selectedFilter.value,
            modelValue: showAddRoleModal.value,
            existingMembers: teamMembers.value,
            teamId: _unref(teamId),
            onCloseAddNonMember: toggleAddNonMemberRoleModal,
            "onUpdate:modelValue": toggleAddNonMemberRoleModal
          }, null, 8, ["role", "modelValue", "existingMembers", "teamId"]),
          _createVNode(EditMembersModal, {
            showEditMembers: showEditMembersModal.value,
            existingMembers: membersUserDetails.value,
            teamId: _unref(teamId),
            teamName: _unref(groupDetails)?.name,
            "onUpdate:showEditMembers": toggleEditMembersModal
          }, null, 8, ["showEditMembers", "existingMembers", "teamId", "teamName"]),
          (inviteControlModel.value)
            ? (_openBlock(), _createBlock(_unref(Modal), {
                key: 3,
                modelValue: showInviteControl.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showInviteControl).value = $event)),
                title: `Invite people to join ${_unref(groupDetails)?.name}`
              }, {
                default: _withCtx(() => [
                  _createVNode(InviteControl, { model: inviteControlModel.value }, null, 8, ["model"])
                ]),
                _: 1
              }, 8, ["modelValue", "title"]))
            : _createCommentVNode("", true),
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(groupDetails)?.name), 1),
          _hoisted_5,
          _createElementVNode("section", null, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("a", {
                href: `/admin/group/edit/${_unref(teamId)}`,
                class: "btn btn-default-edit",
                style: {"margin-right":"2rem"},
                "data-test": "gd-edit-link"
              }, "Edit team", 8, _hoisted_7),
              _createElementVNode("a", {
                href: `/admin/group/delete/${_unref(teamId)}`,
                class: "btn btn-default-close",
                "data-test": "gd-delete-link"
              }, "Delete team", 8, _hoisted_8)
            ]),
            _hoisted_9,
            (!!orgId.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("a", {
                    href: `/organisation/details/${orgId.value}`,
                    class: "btn btn-default",
                    "data-test": "gd-org",
                    role: "link"
                  }, _toDisplayString(_unref(groupDetails)?.organisationName), 9, _hoisted_12)
                ]))
              : _createCommentVNode("", true),
            (hasSubscription.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("p", _hoisted_15, [
                    (!_unref(groupDetails)?.subscription.fixedDates?.startDate)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Subscriptions start when they Complete Solo"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(groupDetails)?.subscription.fixedDates.startDate) + " to " + _toDisplayString(_unref(groupDetails)?.subscription.fixedDates.endDate), 1)),
                    _hoisted_18,
                    _createElementVNode("span", _hoisted_19, "Duration: " + _toDisplayString(_unref(groupDetails)?.subscription.durationInMonths) + " months", 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (!!_unref(groupDetails)?.createdBy)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("a", {
                    href: `/admin/user/details/${_unref(groupDetails)?.createdBy.id}`
                  }, _toDisplayString(_unref(groupDetails)?.createdBy.name), 9, _hoisted_22)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              (_unref(groupDetails)?.notes)
                ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_unref(groupDetails)?.notes), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_26, "No notes"))
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("a", {
                href: scratchpadLink.value.href,
                "data-test": "gd-scratchpad-link"
              }, "Go to scratchpad ✨", 8, _hoisted_28)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("a", {
                href: `/team/watch/${_unref(teamId)}`
              }, "Team Summary", 8, _hoisted_30)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("a", {
                href: _unref(groupDetails)?.canViewSolo ? `/teamreport/view/${_unref(teamId)}` : 'javascript:void(0)',
                "data-test": "gd-team-solo-link"
              }, "Team Solo report", 8, _hoisted_32),
              _createTextVNode(" - "),
              _createElementVNode("a", {
                href: `/teamviewpointsreport/view/${_unref(teamId)}`,
                "data-test": "gd-team-vp-link"
              }, "Team Viewpoints report", 8, _hoisted_33),
              _createTextVNode(" - "),
              _createElementVNode("a", {
                href: `/team/effectiveness/${_unref(teamId)}`,
                "data-test": "gd-teq-link"
              }, "Team effectiveness reviews", 8, _hoisted_34),
              _createTextVNode(" - "),
              _createElementVNode("a", {
                href: `/admin/group/upload/${_unref(teamId)}`,
                "data-test": "gd-upload-link"
              }, "Bulk upload users", 8, _hoisted_35),
              _createTextVNode(" - "),
              _createElementVNode("a", {
                href: `/admin/crmexport/group/${_unref(teamId)}`,
                "data-test": "gd-crm-link"
              }, "CRM Export", 8, _hoisted_36),
              _createTextVNode(" - "),
              _createElementVNode("a", {
                href: `/admin/crmexport/groupdata/${_unref(teamId)}`,
                "data-test": "gd-data-export-link"
              }, "Data Export", 8, _hoisted_37),
              _createTextVNode(" - "),
              _createElementVNode("a", {
                href: `/admin/crmexport/groupterdata/${_unref(teamId)}`,
                "data-test": "gd-ter-export-link"
              }, "TER Export", 8, _hoisted_38),
              _createTextVNode(" - "),
              _createElementVNode("a", {
                href: `/team/heatmap/${_unref(teamId)}`,
                "data-test": "gd-heatmap-link"
              }, "Heatmap", 8, _hoisted_39),
              _createElementVNode("div", null, [
                _createTextVNode(" - "),
                _createElementVNode("a", {
                  href: "javascript:void(0)",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (
                _unref(groupDetails)?.hasManagedSubscription ? copySubInviteCode() : openInviteModal(false)
              )),
                  "data-test": "gd-invite-people-link"
                }, "Invite people to this group")
              ]),
              (!_unref(groupDetails)?.hasManagedSubscription)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createTextVNode(" - "),
                    _createElementVNode("a", {
                      href: "javascript:void(0)",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (openInviteModal(true))),
                      "data-test": "gd-invite-person-link"
                    }, "Invite one person to this group")
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("ul", _hoisted_44, [
                  _createElementVNode("li", {
                    role: "presentation",
                    class: _normalizeClass(selectedFilter.value === _unref(GroupUserRoles).Member ? 'active' : '')
                  }, [
                    _createElementVNode("a", {
                      href: "#members",
                      "aria-controls": "members",
                      role: "tab",
                      "data-toggle": "tab",
                      "data-test": "gd-members-tab",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (applyFilter(_unref(GroupUserRoles).Member)))
                    }, "Members (" + _toDisplayString(_unref(groupDetails)?.groupMembers.length) + ") ", 1)
                  ], 2),
                  _createElementVNode("li", {
                    class: _normalizeClass(selectedFilter.value === _unref(GroupUserRoles).Admin ? 'active' : ''),
                    role: "presentation"
                  }, [
                    _createElementVNode("a", {
                      href: "#teamleads",
                      "aria-controls": "team-leads",
                      role: "tab",
                      "data-toggle": "tab",
                      "data-test": "gd-admins-tab",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (applyFilter(_unref(GroupUserRoles).Admin)))
                    }, "Team Leads (" + _toDisplayString(teamAdmins.value.length) + ")", 1)
                  ], 2),
                  _createElementVNode("li", {
                    role: "presentation",
                    class: _normalizeClass(selectedFilter.value === _unref(GroupUserRoles).Watcher ? 'active' : '')
                  }, [
                    _createElementVNode("a", {
                      href: "#watchers",
                      "aria-controls": "watchers",
                      role: "tab",
                      "data-toggle": "tab",
                      "data-test": "gd-watchers-tab",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (applyFilter(_unref(GroupUserRoles).Watcher)))
                    }, "Watchers (" + _toDisplayString(teamWatchers.value.length) + ")", 1)
                  ], 2)
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              (selectedFilter.value === _unref(GroupUserRoles).Member)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _hoisted_46,
                    _createElementVNode("p", _hoisted_47, _toDisplayString(filteredMembers.value.length) + " team members", 1),
                    _createElementVNode("p", _hoisted_48, _toDisplayString(_unref(groupDetails)?.activeSubscriptions) + " " + _toDisplayString(_unref(groupDetails)?.activeSubscriptions === 1 ? "has" : "have") + " active subscriptions ", 1),
                    _createElementVNode("p", _hoisted_49, _toDisplayString(_unref(groupDetails)?.conflictingSubscriptions) + " " + _toDisplayString(_unref(groupDetails)?.conflictingSubscriptions === 1 ? "has" : "have") + " conflicting subscriptions ", 1)
                  ]))
                : _createCommentVNode("", true),
              (selectedFilter.value === _unref(GroupUserRoles).Admin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _hoisted_51,
                    _createElementVNode("p", _hoisted_52, _toDisplayString(teamAdmins.value.length) + " team lead" + _toDisplayString(teamAdmins.value.length !== 1 ? "s" : ""), 1),
                    (nonMembersWithRoles.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _hoisted_54,
                          _createElementVNode("ul", _hoisted_55, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nonMembersWithRoles.value, (nonMember) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: nonMember.id,
                                class: "non-member-list-item",
                                "data-test": "non-member-admin"
                              }, [
                                _createElementVNode("a", {
                                  href: `/admin/user/details/${nonMember.id}`
                                }, _toDisplayString(nonMember.name), 9, _hoisted_56),
                                _createElementVNode("button", {
                                  class: "btn btn-default",
                                  onClick: ($event: any) => (openNonMemberModal(nonMember)),
                                  "data-test": "remove-non-member-admin",
                                  style: {"max-width":"100px"},
                                  type: "button"
                                }, " Remove ", 8, _hoisted_57)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "btn btn-default",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (toggleAddNonMemberRoleModal(false))),
                      "data-test": "add-non-member-admin",
                      type: "button"
                    }, " Add team lead ")
                  ]))
                : _createCommentVNode("", true),
              (selectedFilter.value === _unref(GroupUserRoles).Watcher)
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    _hoisted_59,
                    _createElementVNode("p", _hoisted_60, _toDisplayString(teamWatchers.value.length) + " watcher" + _toDisplayString(teamWatchers.value.length !== 1 ? "s" : ""), 1),
                    (nonMembersWithRoles.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                          _hoisted_62,
                          _createElementVNode("ul", _hoisted_63, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nonMembersWithRoles.value, (nonMember) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: nonMember.id,
                                class: "non-member-list-item",
                                "data-test": "non-member-watcher"
                              }, [
                                _createElementVNode("a", {
                                  href: `/admin/user/details/${nonMember.id}`
                                }, _toDisplayString(nonMember.name), 9, _hoisted_64),
                                _createElementVNode("button", {
                                  class: "btn btn-default",
                                  onClick: ($event: any) => (openNonMemberModal(nonMember)),
                                  "data-test": "remove-non-member-watcher",
                                  style: {"max-width":"100px"},
                                  type: "button"
                                }, " Remove ", 8, _hoisted_65)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "btn btn-default",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (toggleAddNonMemberRoleModal(false))),
                      "data-test": "add-non-member-watcher",
                      type: "button"
                    }, " Add watcher ")
                  ]))
                : _createCommentVNode("", true),
              _hoisted_66
            ]),
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (toggleEditMembersModal(false))),
                "data-test": "gd-edit-members",
                type: "button"
              }, " Add/Remove Members ")
            ]),
            _hoisted_68,
            _createElementVNode("div", _hoisted_69, [
              (_openBlock(), _createBlock(GroupDetailsTable, {
                key: selectedFilter.value,
                teamMembers: filteredMembers.value,
                teamId: _unref(teamId),
                onOpenRoleModal: openRoleModal,
                onToggleLicenceModal: toggleLicenceModal,
                onToggleAssignLicenceModal: toggleAssignLicenceModal
              }, null, 8, ["teamMembers", "teamId"]))
            ]),
            _hoisted_70,
            _hoisted_71,
            _hoisted_72
          ])
        ]))
      : (_openBlock(), _createBlock(LoadingPage, { key: 2 }))
  ]))
}
}

})